import script from "./Step3.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3.vue?vue&type=script&setup=true&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=7e7294db&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7294db"]])

export default __exports__